// Frontend error hooks. These used to feed Sentry, which was retired on
// 2026-09-24; they now write to the browser console only. The interview
// room's forensic timeline goes to App Insights via
// components/voice-room/lib/events.ts.

type MonitoringContext = Record<string, unknown>;
type MonitoringLevel = "debug" | "info" | "warning" | "error" | "fatal";

export function addMonitoringBreadcrumb(
  message: string,
  data: MonitoringContext = {},
  _level: MonitoringLevel = "info"
) {
  console.debug(`[monitoring] ${message}`, data);
}

export function captureMonitoringMessage(
  message: string,
  context: MonitoringContext = {},
  level: MonitoringLevel = "info"
) {
  if (level === "debug" || level === "info") {
    console.info(`[monitoring] ${message}`, context);
  } else {
    console.warn(`[monitoring] ${message}`, context);
  }
}

export function captureMonitoringError(
  error: unknown,
  context: MonitoringContext = {}
) {
  console.error("[monitoring]", error, context);
}
